import { render } from "./Argument4.vue?vue&type=template&id=5dabc20a"
import script from "./Argument4.vue?vue&type=script&lang=js"
export * from "./Argument4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__